import styled from '@emotion/styled'
import { BREAKPOINTS, pxToRem } from 'utils/styled'
import { css } from '@emotion/react'
import { Text } from 'components/Typography'
import { Stack } from 'components/Stack'

export const SDirectiveSteps = styled.div`
  padding: 0 var(--p-spacing) var(--p-spacing);
  max-width: ${pxToRem(342)}rem;
  height: calc(100vh - var(--h-header));
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 2rem;

  @media ${BREAKPOINTS.LG.max} {
    width: 100%;
    margin-bottom: 4rem;
    max-width: 100vw;
    padding: 0;
    position: relative;
    height: unset;
    flex-direction: column;
    justify-content: space-evenly;
  }
`

export const SStack = styled(Stack)`
  flex-grow: 1;
  @media ${BREAKPOINTS.LG.max} {
    flex-direction: row;
    width: 100%;
    position: relative;
    justify-content: space-evenly;
    align-items: center;
    & > div {
      margin: 0 !important;
      flex: 1;
    }
    &:after {
      content: '';
      position: absolute;
      top: 10px;
      left: 2.25rem;
      right: 2.25rem;
      height: 2px;
      background: var(--c-blue100);
    }
  }

  @media ${BREAKPOINTS.MD.max} {
    &:after {
      left: 0;
      right: 0;
    }
  }
`

export const SItem = styled.div<{
  isActive?: boolean
  isTrailing?: boolean
  disabled?: boolean
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:after {
    content: '';
    height: 100vh;
    width: 2px;
    background: var(--c-blue100);
    right: calc(var(--p-spacing) * -1 + 9px);
    position: absolute;
    top: 50%;
  }

  & svg {
    flex-shrink: 0;
    transform: translateX(calc(var(--p-spacing)));
    position: relative;
    z-index: 1;
  }

  & ${Text} {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &[disabled] {
    & p {
      opacity: ${({ isActive }) => (isActive ? 1 : 0.6)};
    }
    pointer-events: none;
    &:hover {
      text-decoration: none;
    }
  }

  ${({ isActive }) => {
    return isActive
      ? css`
          & ${Text} {
            font-weight: bold;
            color: var(--c-gray100);
          }
        `
      : null
  }}

  ${({ isTrailing }) => {
    return isTrailing
      ? css`
          &:after {
            background: var(--c-blue500);
          }
        `
      : null
  }}

  @media ${BREAKPOINTS.LG.max} {
    flex-direction: column-reverse;
    & svg {
      flex-shrink: 0;
      position: relative;
      z-index: 1;
      transform: unset;
    }
    &:after {
      content: none;
    }
  }
`

export const SDirectiveStepsNav = styled(SDirectiveSteps)`
  top: var(--h-header);

  @media ${BREAKPOINTS.LG.max} {
    top: 2rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    top: 0;
    padding-top: 0.5rem;
    margin-bottom: 0;
  }
`

export const SDirectiveStepsStack = styled(SStack)`
  & > div {
    @media ${BREAKPOINTS.MD.max} {
      flex: unset;
    }
  }
`

export const SDirectiveStepsProcessIcon = styled.div`
  height: 20px;
`

export const SDirectiveStepsValidationErrorIcon = styled.div`
  display: flex;
  align-items: center;
  & {
    margin-right: ${pxToRem(10)}rem;
  }

  @media ${BREAKPOINTS.MD.max} {
    & {
      margin-right: ${pxToRem(4)}rem;
    }
  }
`

export const SDirectiveStepsTextContainer = styled.div`
  display: flex;
`

export const SDirectiveStepsStep = styled.div<{
  isActive?: boolean
  disabled?: boolean
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:after {
    content: '';
    height: 100vh;
    width: 2px;
    background: var(--c-blue100);
    right: calc(var(--p-spacing) * -1 + 9px);
    position: absolute;
    top: 50%;
  }

  ${SDirectiveStepsProcessIcon} svg {
    flex-shrink: 0;
    transform: translateX(calc(var(--p-spacing)));
    position: relative;
    z-index: 1;
  }

  & ${SDirectiveStepsTextContainer} {
    flex-grow: 1;
    overflow: hidden;
    /* margin-right: -${pxToRem(20)}rem; */
    ${Text} {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      @media ${BREAKPOINTS.MD.max} {
        font-size: 0.6875rem;
      }
    }
  }

  &[disabled] {
    & p {
      opacity: ${({ isActive }) => (isActive ? 1 : 0.6)};
    }
    pointer-events: none;
    &:hover {
      text-decoration: none;
    }
  }

  ${({ isActive }) => {
    return isActive
      ? css`
          & ${Text} {
            font-weight: bold;
            color: var(--c-gray100);
          }
        `
      : null
  }}

  @media ${BREAKPOINTS.LG.max} {
    flex-direction: column-reverse;
    ${SDirectiveStepsProcessIcon} svg {
      flex-shrink: 0;
      position: relative;
      z-index: 1;
      transform: unset;
    }
    &:after {
      content: none;
    }
  }
`
